/**
 * 二手车列表
 * http://mockjs.com/
url： https://testzsqy.cheanjia.com/?mock=1#/sms/4
 */
import Mock from 'mockjs'
import cache from '../../common/cache'
let mock = cache.getSessionData('mock')
// mock 开关
let mockSwitch = mock ? '' : '_'
// 接口地址  /api/v1/used_car/tickets
Mock.mock(/used_car\/tickets/, 'put' + mockSwitch, {
  'code': 0,
  'data': {
    'reference_price': null
  },
  'message': 'ok'
})
